import React from 'react';
import { Hero } from './components/Hero';
import { ForYou } from './components/ForYou';
import { ProblemSection } from './components/ProblemSection';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Projects } from './components/Projects';
import { Testimonials } from './components/Testimonials';
import { OfferCard } from './components/OfferCard';
import { NextSteps } from './components/NextSteps';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { useCountdown } from './hooks/useCountdown';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
interface AppProps {
  /** Show the placeholder countdown above the offer card. */
  showCountdown?: boolean;
}
export function App({
  showCountdown = true
}: AppProps) {
  const countdown = useCountdown(30);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3ik7fqfdqo9q4">
      <MetaPixel data-id="element-1" data-mp="3ijpcgysnsv8p" />
      <PurchasePopup data-id="element-2" data-mp="3ii4sg33z0up3" />
      <Hero countdown={countdown} data-id="element-3" data-mp="3mlax56bfqdtg" />
      <main data-id="element-4" data-mp="3mk868ye44bdj">
        <ForYou data-id="element-5" data-mp="3mjzpuwis6nxl" />
        <ProblemSection data-id="element-6" data-mp="3mjg8pi0yg3km" />
        <Modules data-id="element-7" data-mp="3rcj7q5oi4587" />
        <Bonuses data-id="element-8" data-mp="3rbzomln47asl" />
        <Projects data-id="element-9" data-mp="3rdkgg3i1ofmr" />
        <Testimonials data-id="element-10" data-mp="3rd19fhtxnbni" />
        <OfferCard showCountdown={showCountdown} countdown={countdown} data-id="element-11" data-mp="5yk6vxnnffx" />
        <NextSteps data-id="element-12" data-mp="56lvdcob3ly" />
        <Faq data-id="element-13" data-mp="7stfczkdj46" />
        <FinalCta data-id="element-14" data-mp="2zld0l5ad579f" />
      </main>
      <SiteFooter data-id="element-15" data-mp="2zm4wyibsb90r" />
    </div>;
}